import { ApolloClient } from "@apollo/client";
import { Dispatch, SetStateAction } from "react";
import { client } from "../ApolloClient/client";
import { GET_ACTIVITY_HISTORY, GET_ACTIVITY_INFO, GET_CUSTOMER_WORKINCUSTOMERID, GET_EMPTY_ACTIVITY, GET_LAST_ACTIVITY, GET_SALESPERSON_ID, UPDATE_ACTIVITY_STATUS } from "../store/queries";



export const getActivityStatementsFromEmpty = async (
    typeGuid: string,
    setEmptyActivity: Dispatch<SetStateAction<any>>,
    client: ApolloClient<Object>
  ) => {
    try {
      let response = await client.query({
        query: GET_EMPTY_ACTIVITY,
        variables: { paramGuid: typeGuid },
      });
      let stringify = JSON.stringify(response);
      let parsed = JSON.parse(stringify);
  
      const resp = parsed?.data.createEmptyActivity;
      setEmptyActivity(resp);
      if (parsed === undefined) {
        return "FAIL";
      }
      return resp;
    } catch (error) {
      console.log("error getActivityStatementsFromEmpty", error);
    }
  };

  export const getActivityCallHistory = async (lastActivityNumber: number, typeGuid: any, client: ApolloClient<Object>, setCallHistory: any, customerId: number) => {
    try {
        let response = await client.query({
          query: GET_ACTIVITY_HISTORY,
          variables: {lastActivityNumber: lastActivityNumber, paramGuid: typeGuid, customerId: customerId}
        });
        let stringify = JSON.stringify(response)
        let parsed = JSON.parse(stringify)
        
        
        const res = parsed.data.activities.edges
        setCallHistory(res)
      } catch (error) {
        console.log('Hata oluştu: ', error);
      }
  }


  export const getCustomerLastActivity = async ( customerId: number) => {
 
      return await client.query({
        query: GET_LAST_ACTIVITY,
        variables: {
          paramGuid: "2978C75D-D89F-4EE4-8DA4-D82FA90F2605",
          customerId: customerId
        }
      }).then((res: any) => JSON.stringify(res))
      .then((res: any) => JSON.parse(res))
      .then((res: any) => res.data)
      
  }
  export const getActivityInfo = async (setActivityInfo: React.Dispatch<SetStateAction<any>>) => {
    try {
      let response = await client.query({
        query: GET_ACTIVITY_INFO
      });

      let stringify = JSON.stringify(response)
      let parsed = JSON.parse(stringify)


      const res = parsed.data.activityTypes.edges[0].node
      setActivityInfo(res)
    } catch (error) {
      console.log(error);
      
    }
  }

  export const getSalesPersonId = async (setSalesPersonId: React.Dispatch<SetStateAction<any>>, salesPersonId: any) => {
    try {

      let response = await client.query({
        query: GET_SALESPERSON_ID,
        variables: {
          salespersonGuid: salesPersonId
        }
      })

      let stringify = JSON.stringify(response)
      let parsed = JSON.parse(stringify)

      setSalesPersonId(parsed.data.salesPeople.edges[0].node.salesPersonId)

    } catch (error) {

      console.log(error);

    }
  } 

  export const getWorkInCustomerId = async (setWorkInCustomerId: React.Dispatch<React.SetStateAction<string>>, guid: string | undefined) => {
    try {
      await client.query({
        query: GET_CUSTOMER_WORKINCUSTOMERID,
        variables: {
          guid
        }
      })
      .then(res => JSON.stringify(res))
      .then(str => JSON.parse(str))
      .then(parse => parse.data.salesPeople.edges[0].node.salesPersonReference)
      .then(id => setWorkInCustomerId(id.toString()))

    } catch(error) {
      console.log(error)
    }
  }

  export const updateActivityStatus = async(model: {guid: string, updateVersion: any}) => {
    try {
      let response = await client.query({
        query: UPDATE_ACTIVITY_STATUS,
        variables: { model }
      })
      .then(res => JSON.stringify(res))
      .then(res => JSON.parse(res))
      .then(res => res.data)

      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }